var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn btn-secondary",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n        far fa-arrows-rotate\n    ")]),_vm._v("\n    "+_vm._s(_vm.tReload)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }